<template>
  <div class="app-container">
    <div class="data_title data_title_but">
      <img
        src="@/assets/home/statistics_qk.png"
        style="width: 30px;height: 30px;"
      />
      <div class="data_name_title">数据情况</div>
    </div>
    <div class="statistics_warp">
      <div class="statistics_item_warp">
        <img
          src="@/assets/home/statistics_dds.png"
          style="width: 100px;height: 100px;"
        />
        <div class="right_warp">
          <div>在线数量</div>
          <div class="right_value_warp">{{ overview.online }}</div>
        </div>
      </div>
      <div class="statistics_item_warp">
        <img
          src="@/assets/home/statistics_dj2.png"
          style="width: 100px;height: 100px;"
        />
        <div class="right_warp">
          <div>总订单数量</div>
          <div class="right_value_warp">{{ overview.totalOrder }}</div>
        </div>
      </div>
      <div class="statistics_item_warp">
        <img
          src="@/assets/home/statistics_hykh.png"
          style="width: 100px;height: 100px;"
        />
        <div class="right_warp">
          <div>总绑定成功数量</div>
          <div class="right_value_warp">{{ overview.totalBind }}</div>
        </div>
      </div>
      <div class="statistics_item_warp">
        <img
          src="@/assets/home/statistics_kfsl.png"
          style="width: 100px;height: 100px;"
        />
        <div class="right_warp">
          <div>今日订单数量</div>
          <div class="right_value_warp">{{ overview.todayOrder }}</div>
        </div>
      </div>
      <div class="statistics_item_warp">
        <img
          src="@/assets/home/statistics_khs.png"
          style="width: 100px;height: 100px;"
        />
        <div class="right_warp">
          <div>今日绑定数量</div>
          <div class="right_value_warp">{{ overview.todayBind }}</div>
        </div>
      </div>
    </div>

    <div class="data_search_warp">
      <div class="data_title">
        <img
          src="@/assets/home/statistics_sj.png"
          style="width: 30px;height: 30px;"
        />
        <div class="data_name_title">统计数据趋势</div>
      </div>
      <div class="block">
        <el-date-picker
          v-model="listQuery.time"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          format="yyyy-MM-dd"
          @change="getList"
        >
        </el-date-picker>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="dimDate" label="日期" width="160px">
      </el-table-column>
      <el-table-column
        align="center"
        prop="totalOrder"
        label="总订单数量"
      ></el-table-column>
      <el-table-column label="浏览商品数量" align="center" prop="browgoods">
        <template slot-scope="scope">
          <div>
            {{ scope.row.browgoods
            }}<span class="font-color-comm"
              >（{{
                calculationValue(scope.row.totalOrder, scope.row.browgoods)
              }}%）</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="加入购物车数量" align="center" prop="addcart">
        <template slot-scope="scope">
          <div>
            {{ scope.row.addcart
            }}<span class="font-color-comm"
              >（{{
                calculationValue(scope.row.totalOrder, scope.row.addcart)
              }}%）</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="进入结算数量" align="center" prop="settle">
        <template slot-scope="scope">
          <div>
            {{ scope.row.settle
            }}<span class="font-color-comm"
              >（{{
                calculationValue(scope.row.totalOrder, scope.row.settle)
              }}%）</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="填写支付信息数量" align="center" prop="payinfo">
        <template slot-scope="scope">
          <div>
            {{ scope.row.payinfo
            }}<span class="font-color-comm"
              >（{{
                calculationValue(scope.row.totalOrder, scope.row.payinfo)
              }}%）</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="获取验证码数量" align="center" prop="takecode">
        <template slot-scope="scope">
          <div>
            {{ scope.row.takecode
            }}<span class="font-color-comm"
              >（{{
                calculationValue(scope.row.totalOrder, scope.row.takecode)
              }}%）</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提交验证码数量" align="center" prop="submitcode">
        <template slot-scope="scope">
          <div>
            {{ scope.row.submitcode
            }}<span class="font-color-comm"
              >（{{
                calculationValue(scope.row.totalOrder, scope.row.submitcode)
              }}%）</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="绑定成功数量" align="center" prop="bind">
        <template slot-scope="scope">
          <div>
            {{ scope.row.bind
            }}<span class="font-color-comm"
              >（{{
                calculationValue(scope.row.totalOrder, scope.row.bind)
              }}%）</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getFlowpProgressStatis, getOverviewStatis } from "@/api/user";
import { formatApiDate, calculationValue } from "@/utils/utils";
import moment from "moment";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    calculationValue() {
      return calculationValue;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      listQuery: {
        time: [new Date().getTime() - 3600 * 1000 * 24 * 7, new Date()]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      listLoading: false,
      list: [],
      overview: {
        online: 0, //在线数量
        totalOrder: 0, // 总订单数量
        totalBind: 0, // 总绑定数量
        todayOrder: 0, // 今日订单数量
        todayBind: 0 // 今日绑定数量
      }
    };
  },
  created() {
    this.getList();
    this.getOverviewStatisFun();
  },
  watch: {},
  methods: {
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const params = {};
      const form = this.listQuery;
      if (form.time) {
        params.startTime = moment(
          moment(form.time[0]).format("YYYY-MM-DD") + " 00:00:00"
        ).valueOf();
        params.endTime = moment(
          moment(form.time[1]).format("YYYY-MM-DD") + " 23:59:59"
        ).valueOf();
      }
      console.log("params", params);
      getFlowpProgressStatis(params)
        .then(response => {
          this.list = response.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    getOverviewStatisFun() {
      getOverviewStatis()
        .then(response => {
          this.overview = response.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
.data_title {
  font-size: 18px;
  color: #000000;
  display: flex;
  align-items: center;
  padding: 20px 0;
  .data_name_title {
    font-size: 18px;
    color: #000000;
    margin-left: 10px;
  }
}
.data_title_but {
  width: 100%;
  border-bottom: 1px solid #eeeeee;
}
.data_search_warp {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.statistics_warp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  .statistics_item_warp {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 20px;
    width: 16%;
    .right_warp {
      margin-left: 20px;
      font-weight: 300;
      font-size: 14px;
      color: #000000;
    }
    .right_value_warp {
      font-weight: bold;
      font-size: 28px;
      color: #000000;
      margin-top: 10px;
    }
  }
}
.font-color-comm {
  color: #8bc34a;
}
</style>
